import { intl } from "LocaleWrapper";
import { Card, Table } from "@cofano/cck";
import DirectionsBoatIcon from "@mui/icons-material/DirectionsBoat";
import { TableId, useFrontendTable } from "components/table";
import { PurchaseCharterVoyage } from "view/charters/PurchaseCharterDetails";
import useVoyageTable from "view/voyages/hooks/useVoyageTable";
import { DetailsBlock, Height } from "../Blocks";

type PurchaseCharterVoyagesBlockProps = {
	voyages?: PurchaseCharterVoyage[];
	color: string;
	loading?: boolean;
	onSelect?: (voyageId: number | undefined) => void;
	refetch: () => void;
};

const PurchaseCharterVoyagesBlock = ({ voyages, color, onSelect, refetch }: PurchaseCharterVoyagesBlockProps) => {
	const { tableProps } = useFrontendTable({
		id: TableId.PurchaseCharterVoyages,
		content: voyages ?? [],
	});

	const { columns } = useVoyageTable<PurchaseCharterVoyage>({
		refetch: refetch,
	});

	return (
		<DetailsBlock height={Height.Fill}>
			<Card
				color={color}
				icon={<DirectionsBoatIcon sx={{ color: color }} fontSize="small" />}
				title={intl.formatMessage({ id: "VOYAGES" })}
				disablePadding>
				<Table
					{...tableProps}
					columns={Object.values(columns).map(it => ({
						...it,
						sortable: false,
						filterComponent: undefined,
					}))}
					onRowClick={(row) => onSelect ? onSelect(row?.id) : undefined}
				/>
			</Card>
		</DetailsBlock>
	);
};

export default PurchaseCharterVoyagesBlock;
